import { channelNav, channelTab, banksNav } from './service';
import { Effect } from 'umi';
import { Reducer } from '@@/plugin-dva/connect';

export interface ChannelType {
  channelArray: channelArrayObj[];
  id: number;
  bank: {
    id: number;
    level: string;
    title: string;
  };
  sections: [];
  banks: {
    created_at: string;
    id: number;
    level: string;
    super_id: number;
    title: string;
    updated_at: string;
  }[];
  modules: modulesType[];
  index: number;
}
export interface channelArrayObj {
  id: number;
  modules: modulesType[];
  sections: any[];
  super_id: number;
  title: string;
}

export interface modulesType {
  created_at: string;
  id: number;
  title: string;
  chapters: {
    id: string;
    super_id: number;
    title: string;
    papers: {
      id: string;
      paper_id: string;
      title: string;
      desc: string;
      number: number;
      finishCount: number;
      last_exam: {
        id: number;
        paper_id: string;
        records_count: number;
      } | null;
    }[];
  }[];
}

export interface ModelType {
  namespace: string;
  state: ChannelType;
  effects: {
    default: Effect;
    // banksNavChange: Effect;
    subjectSaveChange: Effect;
    channelSaveChange: Effect;
  };
  reducers: {
    save: Reducer;
    changeSave: Reducer;
    bankSave: Reducer;
    defaultSave: Reducer;
    setState: Reducer;
  };
}

const Model: ModelType = {
  namespace: 'channel',

  state: {
    banks: [],
    channelArray: [],
    id: 0,
    index: 0,
    sections: [],
    bank: {
      id: 0,
      level: '',
      title: '',
    },
    modules: [],
  },

  effects: {
    *default({ payload, callback }, { call, put }) {
      const response = yield call(banksNav);
      if (response && response.error_code === 0) {
        yield put({
          type: 'bankSave',
          payload: response,
        });
        if (callback) callback(response);
      }
    },

    *channelSaveChange({ payload, callback }, { call, put }) {
      const response = yield call(channelNav, payload);
      yield put({
        type: 'save',
        payload: response,
      });
      if (callback) callback(response);

      if (response.data.subjects.length > 0) {
        yield put({
          type: 'subjectSaveChange',
          payload: {
            id: response.data.subjects[0].id,
            index: 0,
          },
        });
      } else {
        yield put({
          type: 'defaultSave',
        });
      }
    },

    *subjectSaveChange({ callback, payload }, { call, put }) {
      const response = yield call(channelTab, payload.id);
      yield put({
        type: 'changeSave',
        payload: {
          ...response,
          index: payload.index,
        },
      });
      if (callback) callback(response);
    },
  },
  reducers: {
    bankSave(state, { payload }) {
      return {
        ...state,
        banks: payload.data,
      };
    },
    save(state, { payload }) {
      return {
        ...state,
        channelArray: payload.data.subjects,
        bank: payload.data.bank,
      };
    },
    changeSave(state, { payload }) {
      const data = [...state.channelArray];
      const dataIndex = payload.index;
      data[dataIndex] = {
        ...data[dataIndex],
        ...payload.data,
      };
      return {
        ...state,
        id: data[dataIndex].id,
        index: payload.index,
        channelArray: data,
      };
    },
    defaultSave(state) {
      return {
        ...state,
        sections: [],
        modules: [],
      };
    },
    setState(state, { payload }) {
      const { type, value } = payload;
      return {
        ...state,
        [type]: value,
      };
    },
  },
};

export default Model;
